const layoutTypes = {
    column: "COLUMN",
    row: "ROW",  
}

export default layoutTypes